import { Instructor } from 'fitbeat.models';
import { IInstructorsRepository } from '../interfaces';

export const HOME_PERSONAL_TRAINERS = 'HOME_PERSONAL_TRAINERS';

export class DbInstructorsRepository implements IInstructorsRepository {

    constructor(private db: any, private logger: any) { }

    public async createDefaultDoc(): Promise<void> {
        try {
            const defaultPts = {
                _id: HOME_PERSONAL_TRAINERS,
            };
            await this.db.put(defaultPts);
        } catch (e) {
            if (e.status === 409) {
                this.logger.info(`${HOME_PERSONAL_TRAINERS} document already exists`);
                return;
            }
            throw e;
        }
    }

    public async getAllActive(): Promise<Instructor[]> {
        const docs = await this.db.get(HOME_PERSONAL_TRAINERS);
        const instructors: Instructor[] =
            docs.instructors.filter((pt: Instructor) => pt.isActive);
        return instructors;
    }

    public async getAll(): Promise<Instructor[]> {
        const docs = await this.db.get(HOME_PERSONAL_TRAINERS);
        const instructors: Instructor[] = docs.instructors;
        return instructors;
    }
}
